import JSEncrypt from "jsencrypt";
import store from "@/store";

export default function rsaEncrypt(word) {
    const publicKey = store.getters["User/publicKey"].publicKey
    if (publicKey == null) {
        console.error("publicKey is null");
        return null;
    }
    let encrypt = new JSEncrypt();
    encrypt.setPublicKey(publicKey);
    const rsaWord = encrypt.encrypt(word);
    if (rsaWord === false) {
        return null;
    }
    return rsaWord;
}
